import { Container, TextPageHeader } from '@carboncopyco/ui';
import { useDashboardAnalytics } from '@carboncopyco/utils';
import { Tab } from '@headlessui/react';
import classNames from 'classnames';
import { useDashboardProps } from '../DashboardContext';
import { RangeFilter } from './RangeFilter';
import { SettingsMenu } from './SettingsMenu';
import { StyledTab } from './StyledTab';
import { TagsFilter } from './TagsFilter';
import { WorkspaceFilter } from './WorkspaceFilter';

export const DashboardHeader = () => {
  const { setTab, isScrolling, tab } = useDashboardProps();
  const { trackDashboardTabsClick } = useDashboardAnalytics();

  return (
    <header
      className={classNames(
        'h-36 w-full flex flex-col bg-ds-natural-50 pt-8 z-50 transition-shadow',
        { 'shadow-ds-lg': isScrolling }
      )}
    >
      <Container>
        <div
          className={classNames('h-full w-full flex flex-col ', {
            'border-b border-b-ds-natural-150': !isScrolling,
          })}
        >
          <div className="flex justify-between w-full [&>div]:p-0">
            <TextPageHeader label="Analytics" />
            <SettingsMenu />
          </div>
          <div className="flex justify-between mt-auto">
            <Tab.Group
              defaultIndex={tab === 'tour' ? 1 : 0}
              onChange={(index) => {
                const tab = index ? 'tour' : 'demo';
                setTab(tab);
                trackDashboardTabsClick({
                  dashboardTab: tab,
                });
              }}
            >
              <Tab.List>
                <StyledTab>Demos</StyledTab>
                <StyledTab>Tours</StyledTab>
              </Tab.List>
            </Tab.Group>
            <div className="flex gap-4">
              <TagsFilter />
              <WorkspaceFilter />
              <RangeFilter />
            </div>
          </div>
        </div>
      </Container>
    </header>
  );
};
